/* tslint:disable */
/* eslint-disable */
/**
 * Profile API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


/**
 * 
 * @export
 */
export const AvailabilityStatus = {
    Available: 'AVAILABLE',
    OnProject: 'ON_PROJECT',
    OnSelectionList: 'ON_SELECTION_LIST'
} as const;
export type AvailabilityStatus = typeof AvailabilityStatus[keyof typeof AvailabilityStatus];


export function instanceOfAvailabilityStatus(value: any): boolean {
    for (const key in AvailabilityStatus) {
        if (Object.prototype.hasOwnProperty.call(AvailabilityStatus, key)) {
            // @ts-ignore
            if (AvailabilityStatus[key] === value) {
                return true;
            }
        }
    }
    return false;
}

export function AvailabilityStatusFromJSON(json: any): AvailabilityStatus {
    return AvailabilityStatusFromJSONTyped(json, false);
}

export function AvailabilityStatusFromJSONTyped(json: any, ignoreDiscriminator: boolean): AvailabilityStatus {
    return json as AvailabilityStatus;
}

export function AvailabilityStatusToJSON(value?: AvailabilityStatus | null): any {
    return value as any;
}

